<template>
  <section>
    <h1 class="sponsor__title">VIP Section: $118</h1>
    <div
      class="yachad-styled styled-radio-container styled-radio-container--ou-donation row"
    >
      <div class="amount-row">
        <input
          id="vipmen"
          type="checkbox"
          class="amount"
          @click="selectedAmount = 'vipmen'"
        />
        <FormLabel for="vipmen">
          <div class="money_format label-amount">VIP Men's Section</div>
          <span class="label-description">(15 seats available)</span>
        </FormLabel>
      </div>
      <div class="amount-row">
        <input
          id="vipwomen"
          type="checkbox"
          class="amount"
          @click="selectedAmount = 'vipwomen'"
        />
        <FormLabel for="vipwomen">
          <div class="money_format label-amount">VIP Women's Section</div>
          <span class="label-description">(15 seats available)</span>
        </FormLabel>
      </div>
      <div class="amount-row">
        <input
          id="vipfamily"
          type="checkbox"
          class="amount"
          @click="selectedAmount = 'vipfamily'"
        />
        <FormLabel for="vipfamily">
          <div class="money_format label-amount">VIP Family Section</div>
          <span class="label-description">(24 seats available)</span>
        </FormLabel>
      </div>
    </div>
    <h1 class="sponsor__title">General Admission: $54</h1>
    <div
      class="yachad-styled styled-radio-container styled-radio-container--ou-donation row"
    >
      <div class="amount-row">
        <input
          id="genmen"
          type="checkbox"
          class="amount"
          @click="selectedAmount = 'genmen'"
        />
        <FormLabel for="genmen">
          <div class="money_format label-amount">Men's Section</div>
          <span class="label-description">(50 seats available)</span>
        </FormLabel>
      </div>
      <div class="amount-row">
        <input
          id="genwomen"
          type="checkbox"
          class="amount"
          @click="selectedAmount = 'genwomen'"
        />
        <FormLabel for="genwomen">
          <div class="money_format label-amount">Women's Section</div>
          <span class="label-description">(50 seats available)</span>
        </FormLabel>
      </div>
      <div class="amount-row">
        <input
          id="genfamily"
          type="checkbox"
          class="amount"
          @click="selectedAmount = 'genfamily'"
        />
        <FormLabel for="genfamily">
          <div class="money_format label-amount">Family Section</div>
          <span class="label-description">(80 seats available)</span>
        </FormLabel>
      </div>
    </div>

    <ErrorLabel field="amount" />

    <div
      class="clear__btn"
      v-if="form.amount && Number(form.amount) > 0"
      @click="clearOutSelectedValue"
    >
      Clear Selection
    </div>

    <ul class="payment__totals" v-if="form.amount && Number(form.amount) > 0">
      <li class="payment__summary">Summary</li>
      <li v-if="selectedAmount">
        <div class="payment__tot__desc">Sponsorship:</div>
        <div class="payment__tot__amt">
          <span>${{ selectedAmount }}</span>
        </div>
      </li>
      <!-- <li v-if="singleReservation || coupleReservation || yachadMember">
        <div class="payment__tot__desc">Tickets:</div>
        <div class="payment__tot__amt">
          <span v-if="singleReservation">Single Ticket</span>
          <span v-if="coupleReservation">Couple Ticket</span>
          <span v-if="yachadMember">Yachad Member</span>
        </div>
      </li> -->
      <li v-if="form.amount && Number(form.amount)">
        <div class="payment__tot__desc">Total Amount:</div>
        <div class="payment__tot__amt">
          <span class="pay__total">${{ form.amount }}</span>
        </div>
      </li>
    </ul>
    <!-- <FormRow>
      <div style="width: 100%" class="coupon__field">
        <FormLabel class="control-label"> Coupon Code: </FormLabel>
        <FormInput type="text" class="width-half" field="custom.coupon" />
      </div>
    </FormRow> -->
  </section>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch, nextTick } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

export default defineComponent({  setup() {
    const { setValue, form, settings, getValue } = usePaymentForm();

    const selectedAmount = ref();
    const selectedAllocationAmount = ref();
    const customAmount = ref(form.value.amount);
    const customSelected = ref(false);

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customSelected.value = false;

        customAmount.value = null;

        // if (selectedAllocationAmount.value) {
        //   setValue(
        //     "amount",
        //     "" + (parseInt(selectedAmount) + selectedAllocationAmount.value)
        //   );
        // } else {
        //   setValue("amount", "" + selectedAmount);
        // }
      }
    });

    watch(customSelected, (customSelected) => {
      if (customSelected) {
        selectedAmount.value = null;
        selectedAllocationAmount.value = null;
        setValue("amount", null);
      }
    });

    watch(customAmount, async (customAmount) => {
      if (customAmount) {
        selectedAmount.value = null;
        selectedAllocationAmount.value = null;
        customSelected.value = true;
      }

      // make sure UI has vue has dealt with customSelected and then we'll set the customAmount
      await nextTick();

      if (!selectedAmount.value) {
        setValue("amount", customAmount || null);
      }
      if (!selectedAllocationAmount.value) {
        setValue("amount", customAmount || null);
      }
    });

    function clearOutSelectedValue() {
      selectedAmount.value = null;
      selectedAllocationAmount.value = null;
      setValue("amount", null);
    }

    const amounts = computed(() => {
      const amounts = settings!.amounts! as
        | [number, string][]
        | [Partial<{ [key in Currency]: number }>, string][];

      if (typeof amounts[0][0] == "number") return amounts;

      return (amounts as [
        Partial<{ [key in Currency]: number }>,
        string
      ][]).map(([amounts, label]) => [amounts[form.value.currency!], label]);
    });
    const params = queryParams();

    if (params.amount) {
      //@ts-ignore
      if (
        //@ts-ignore
        amounts.value.includes(+params.amount) ||
        //@ts-ignore
        amounts.value.map((x) => x[0]).includes(+params.amount)
      ) {
        selectedAmount.value = params.amount;
      } else {
        customAmount.value = params.amount;
      }
    }

    return {
      getValue,
      setValue,
      form,
      amounts,
      selectedAmount,
      selectedAllocationAmount,
      customAmount,
      clearOutSelectedValue,
      customSelected,
    };
  },
});
</script>
<style scoped lang="scss">
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;

  input[type="radio"] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    display: block;
    height: 100%;
    display: flex;
    overflow: hidden;
  }
  input[type="radio"]:checked + label {
    background: #0075ff;
    color: white;
  }
  input[type="radio"]:checked + label .label-amount {
    background: #0367de;
    border-color: #1849ff;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    position: relative;
    min-width: 22%;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding-left: 5px;
    flex: 1;
    line-height: 1;
    @media (max-width: 720px) {
      margin-right: 5px;
      margin-left: 5px;
      margin-bottom: 10px;
    }
    &:before {
      content: "$";
      font-weight: 500 !important;
      position: absolute;
      padding: 15px 8px;
      border-right: 1px solid #ddd;
      height: 100%;
      background: #f7f7f7;
      text-align: center;
      top: 0px;
      left: 0;
      width: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    input[type="number"] {
      border: none;
      background: #fff;
      margin-left: 70px;
      box-shadow: none;
      max-width: 85%;
    }
  }
}
input#tickets_qnt {
  background: #fff !important;
  box-shadow: none;
}
.amount-row {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  width: 100%;
  @media (min-width: 720px) {
    min-width: 49%;
    max-width: 49%;
  }
}
.amount {
  margin-right: 7px;
}
.label-amount {
  font-weight: 500;
  display: inline-block;
  padding: 10px 5px 0px;
  align-items: center;
  min-width: 70px;
  max-width: 70px;
  justify-content: center;
  background: #f7f7f7;
  height: 100%;
  display: flex;
  border-right: 1px solid #efefef;
  @media (min-width: 720px) {
    padding: 5px 5px 0px;
  }
}
.amount-row:hover {
  .label-amount {
    border-right: 1px solid #ddd;
    background: #efefef;
  }
}
#amount_other {
  max-width: 200px;
}
.label-description {
  font-weight: normal;
  padding: 0px 5px 10px;
  align-items: center;
  justify-content: center;
  height: auto;
  display: flex;
  font-size: 12px;
  line-height: 1.4;
}
.yachad-styled.styled-radio-container--ou-donation.styled-radio-container label {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
}
.amount_other__wrapper.amount-row {
  @media (max-width: 720px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
  }
}
.amount-row.tickets-num {
  @media (max-width: 720px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
    margin-top: 10px;
  }
}
::v-deep h1.sponsor__title {
  margin-bottom: 20px;
  margin-top: 40px;
  font-weight: 200;
  font-size: 30px;
  text-transform: uppercase;
  text-align: center;
  color: black;
}
ul.payment__totals {
  padding: 15px 0px 0px;
  margin: 20px auto 0px;
  max-width: 320px;
  width: 100%;
  border-top: 1px solid #eff2f6;
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: wrap;
    padding: 0px 0px 4px;
    margin-bottom: 12px;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.75px;
    color: #4b5866;

    &.payment__summary {
      text-align: center;
      flex: 1;
      width: 100%;
      justify-content: center;
    }
  }

  .payment__tot__desc {
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 15px;
    text-transform: capitalize;
    color: #232e38;
  }
  .payment__tot__amt {
    width: 50%;
    font-size: 14px;
    font-style: italic;
    line-height: 18px;
    text-align: right;
    color: black;
    span {
      display: block;
      &.pay__total {
        font-style: normal;
        font-weight: 600;
      }
    }
  }
}

.clear__btn {
  color: rgba(215, 203, 158, 1);
  border: none;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-size: 13px;
  transition: 0.3s;
  padding: 12px 25px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 20px auto 0px;
  border: 1px solid #e8e8e8;
  max-width: 200px;
  border-radius: 4px;
  &:hover {
    background: #fafafa;
    color: black;
  }
}

.coupon__field {
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
  margin-top: 24px;
  ::v-deep .control-label {
    padding-bottom: 5px;
  }
}
.discount-label {
  color: #333;
  text-decoration: line-through;
}
</style>
